import React, {useEffect} from "react"
import ComponentWrapper from "../../../common/components/ComponentWrapper"
import {useNavigate} from "react-router-dom"
import {useCustomer} from "../../../common/contexts/CustomerContext"
import ParentDashboard from "../components/ParentDashboard"
import {useGetCustomerIsParent} from "@murphy-frontend/common/api/Customers/Queries"
import Spinner from "@murphy-frontend/web-core/components/Spinner"
import {IconContext} from "react-icons/lib"
import {IoChevronBackOutline} from "react-icons/io5"
import Button from "@murphy-frontend/web-core/components/Button"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"

const TMSDashBoardParent = () => {
	const navigate = useNavigate()
	const {customer} = useCustomer()

	const {data: isParent, isPending, isLoading: isLoadingParent} = useGetCustomerIsParent(customer.Id)
	const {translations} = useUserPreferences()

	useEffect(() => {
		if (!isPending) {
			if (!isParent) {
				navigate(`/tmsStartpage/${customer.Id}`)
			}
		}
	}, [isPending])

	if (isLoadingParent || isPending) {
		return (
			<ComponentWrapper active={3} subMenuActive={1}>
				<div className='spinner-container-global-center'>
					<Spinner />
				</div>
			</ComponentWrapper>
		)
	}

	return (
		<div>
			<ComponentWrapper active={3} subMenuActive={1}>
				<section className='header-btns'>
					<div className='header-back-btn'>
						<Button buttonSize={"btn--medium"} isLightButton={true} onClick={() => navigate("/")}>
							<IconContext.Provider value={{className: "btn-icon"}}>
								<IoChevronBackOutline />
							</IconContext.Provider>
							&nbsp; {translations.back}
						</Button>
						<div className='header-back-btn margin-top-20 margin-bottom-10'>
							<h2>Dashboard</h2>
						</div>
					</div>
				</section>
				<ParentDashboard />
			</ComponentWrapper>
		</div>
	)
}

export default TMSDashBoardParent
